var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUseraccountSupport(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5B70FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96,20.2c-14.2,0-25.8,11.6-25.8,25.8c0,3.5,0.7,7,2.1,10.2l-4.3,15.1c-0.2,0.9,0,1.8,0.7,2.5 c0.5,0.5,1.1,0.7,1.7,0.7c0.3,0,0.5,0,0.8-0.1l14.6-4.6c3.2,1.4,6.6,2.1,10.1,2.1c14.2,0,25.8-11.6,25.8-25.8S110.2,20.2,96,20.2z  M96,66.7c-3,0-6-0.6-8.7-1.9c-0.6-0.3-1.3-0.4-2-0.2l-11.1,3.5l3.2-11.5c0.2-0.6,0.1-1.2-0.1-1.8c-1.3-2.8-2-5.8-2-8.9 c0-11.4,9.3-20.8,20.8-20.8s20.8,9.3,20.8,20.8S107.5,66.7,96,66.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.2,99.4L89.8,90c-1.6-1.4-3.1-1.6-4.2-1.5c-2.3,0.2-3.8,1.7-4.2,2.2l-4.8,5.3c-3.2,3.6-6.1,1.5-6.9,0.9 L49.2,78.3c0,0-1.4-1.4-1.5-3.2c-0.1-1.2,0.5-2.5,1.6-3.8l4.8-5.2c0.3-0.3,1.9-2,1.8-4.4c0-1-0.4-2.6-2-4l-10.4-9.4 c-0.1-0.1-0.2-0.1-0.3-0.2c-1.6-1.1-5.3-2.2-8.2,1l-0.9,1c-4.6,5-10.2,11.3-11.2,19.4c-1.2,9.7,6,17.5,13.2,23.8l21.4,19.3 c0.1,0.1,0.2,0.1,0.3,0.2c7.1,6.3,14.3,9.4,21.4,9.4c0.6,0,1.2,0,1.8-0.1c7.4-0.5,12.8-6.9,17.2-11.9c0.7-0.8,1.4-1.7,2.1-2.4 c3-3.3,1.4-6.9,0.2-8.3C100.4,99.5,100.3,99.5,100.2,99.4z M38.8,52.5c0.2-0.2,0.7-0.8,1.6-0.3l10.2,9.2c0.2,0.2,0.3,0.3,0.3,0.4 c0,0.2-0.2,0.6-0.4,0.8l-3.3,3.6L35.7,55.9c0.7-0.8,1.4-1.6,2.1-2.4L38.8,52.5z M80.6,117.3c-6.4,0.5-13.1-2.3-19.7-8.3 c-0.1-0.1-0.2-0.1-0.3-0.2L39.4,89.6c-6.2-5.5-12.5-12-11.5-19.5c0.5-3.8,2.3-7.2,4.7-10.4L44,70.1c-1,1.7-1.4,3.4-1.3,5.2 c0.2,3.9,2.9,6.4,3.2,6.6l20.6,18.5c2.5,2.2,7.4,3.9,12,0.6l11.8,10.6C87.3,114.6,84.2,117,80.6,117.3z M96.5,104.6 c-0.7,0.8-1.4,1.6-2.2,2.5c-0.3,0.3-0.5,0.6-0.8,0.9L82,97.6l3.3-3.6c0.2-0.2,0.6-0.5,0.8-0.5c0.1,0,0.3,0.1,0.4,0.3l10.2,9.2 C97.3,103.8,96.7,104.4,96.5,104.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.1,43.4c-1.6,0-2.8,1.3-2.8,2.8s1.3,2.8,2.8,2.8c1.6,0,2.8-1.3,2.8-2.8S87.6,43.4,86.1,43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.4,43.4c-1.6,0-2.8,1.3-2.8,2.8s1.3,2.8,2.8,2.8c1.6,0,2.8-1.3,2.8-2.8S98,43.4,96.4,43.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 106.5,
    cy: 46.3,
    r: 2.8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUseraccountSupport);
export default __webpack_public_path__ + "static/media/icon-useraccount-support.d1cda434.svg";
export { ForwardRef as ReactComponent };